import { render, staticRenderFns } from "./LayoutBasic.vue?vue&type=template&id=4583f888&scoped=true"
import script from "./LayoutBasic.vue?vue&type=script&lang=js"
export * from "./LayoutBasic.vue?vue&type=script&lang=js"
import style0 from "./LayoutBasic.vue?vue&type=style&index=0&id=4583f888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4583f888",
  null
  
)

export default component.exports